import { render, staticRenderFns } from "./WillBeneficiariesManagingFinancesPeople.vue?vue&type=template&id=9cdefd9e"
import script from "./WillBeneficiariesManagingFinancesPeople.vue?vue&type=script&lang=js"
export * from "./WillBeneficiariesManagingFinancesPeople.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports